<template>
  <VendorForm mode="Ubah" module="Mitra"> </VendorForm>
</template>

<script>
import VendorForm from './form';

const VendorUpdate = {
  name: 'VendorUpdate',
  components: { VendorForm },
};

export default VendorUpdate;
</script>
